import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';

const TermsOfService = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center mb-8">
          <Link to="/" className="flex items-center text-gray-600 hover:text-indigo-600">
            <FiArrowLeft className="w-5 h-5 mr-2" />
            <span>Back to Home</span>
          </Link>
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>

        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-600">
              By accessing or using EventsAwa, you agree to be bound by these Terms of Service
              and all applicable laws and regulations. If you do not agree with any of these
              terms, you must not use our platform.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. User Accounts</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Account Registration</h3>
                <ul className="list-disc list-inside text-gray-600">
                  <li>You must provide accurate and complete information during registration</li>
                  <li>You are responsible for maintaining the confidentiality of your account</li>
                  <li>You must be at least 18 years old to use our services</li>
                </ul>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Account Termination</h3>
                <p className="text-gray-600">
                  We reserve the right to terminate or suspend accounts that violate these terms
                  or engage in fraudulent activities.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Event Management</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Event Creation</h3>
                <ul className="list-disc list-inside text-gray-600">
                  <li>You must have the right to create and manage events</li>
                  <li>Events must comply with all applicable laws and regulations</li>
                  <li>You are responsible for the content and accuracy of event information</li>
                </ul>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Event Participation</h3>
                <p className="text-gray-600">
                  Users must comply with event organizers' rules and regulations when attending
                  events managed through EventsAwa.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Payment Terms</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Event Fees</h3>
                <p className="text-gray-600">
                  Event organizers are responsible for setting and collecting event fees. We
                  provide the platform for processing payments but are not responsible for
                  disputes regarding fees.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Refunds</h3>
                <p className="text-gray-600">
                  Refund policies are determined by event organizers. Please check the specific
                  event's refund policy before registering.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Intellectual Property</h2>
            <div className="space-y-4">
              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">Platform Content</h3>
                <p className="text-gray-600">
                  All content on the EventsAwa platform is protected by intellectual property
                  laws. You may not use or reproduce content without proper authorization.
                </p>
              </div>

              <div className="border-l-4 border-indigo-500 pl-4">
                <h3 className="font-semibold text-gray-700">User-Generated Content</h3>
                <p className="text-gray-600">
                  You retain ownership of content you submit to the platform, but you grant us
                  a non-exclusive license to use, display, and distribute your content.
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
            <p className="text-gray-600">
              We are not liable for any damages or losses resulting from the use of our
              platform, including but not limited to event cancellations, payment disputes, or
              data breaches.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Changes to Terms</h2>
            <p className="text-gray-600">
              We reserve the right to modify these Terms of Service at any time. Continued use
              of the platform after changes constitutes acceptance of the modified terms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Information</h2>
            <p className="text-gray-600">
              If you have any questions about these Terms of Service, please contact us through
              our support channels.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
